import { LoadingModalProps, UserInfo, Error } from "../models";
import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./states/user";
import { loadingSlice } from "./states/loading";
import { productSlice } from "./states/product";
import { errorSlice } from "./states/error";

export interface AppStore {
  user: UserInfo;
  loading: LoadingModalProps;
  product: number; 
  error: Error;
}

export default configureStore<AppStore>({
  reducer: {
    user: userSlice.reducer,
    loading: loadingSlice.reducer,
    product: productSlice.reducer, 
    error: errorSlice.reducer
  },
});